import React from 'react';
import { Box } from '@mui/material';
import Logo from 'src/assets/images/Logo.png';
import { StyledEmptyStateImage } from '../StyledComponents/StyledEmptyState';

interface OrderSidebarHeaderProps {
  smScreen?: boolean;
}

const SidebarHeader: React.FC<OrderSidebarHeaderProps> = ({
  smScreen = false,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="flex-start"
      width="100%"
      maxWidth={1200}
      p={2}
      ml={2}
    >
      <Box display="flex" alignItems="center">
        <StyledEmptyStateImage src={Logo} />
      </Box>
    </Box>
  );
};

export default SidebarHeader;
